import { Button, Icon, Spinner } from "@qw/ui";
import { useCreateDraft } from "@/providers/use-create-draft";

export const CreateDraftButton = () => {
  const [createDraft, { loading: isLoadingDraft }] = useCreateDraft();

  return (
    <Button
      size="sm"
      variant="secondary"
      theme="primary"
      onClick={() => createDraft()}
      className="flex-none gap-3 text-base"
    >
      Compose
      {isLoadingDraft ? <Spinner /> : <Icon icon="edit" />}
    </Button>
  );
};
